import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
export function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="flex flex-col rounded-xl border border-gray-200 bg-gray-50 p-7 transition-shadow duration-150 ease-out hover:shadow-md" data-id="element-189" data-mp="2kgq5yk64snvh">
      {testimonial.foto && <img src={testimonial.foto} alt={`Foto de ${testimonial.nombre}`} width={80} height={80} loading="lazy" decoding="async" className="mb-5 h-20 w-20 rounded-full border-[3px] border-mint object-cover" data-id="element-190" data-mp="2u71igv3vs5dz" />}
      <div className="mb-3 flex gap-0.5 text-amber" role="img" aria-label="Calificación 5 de 5 estrellas" data-id="element-191" data-mp="386kbshs19c68">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="h-[18px] w-[18px] fill-amber" aria-hidden="true" data-id="element-192" data-mp="19sium169jttt" data-mpi={i} />)}
      </div>
      <p className="flex-1 text-base italic leading-relaxed text-gray-800" data-id="element-193" data-mp="1dum44k9dgocg">“{testimonial.texto}”</p>
      <p className="mt-5 text-sm font-bold text-mint-dark" data-id="element-194" data-mp="huxgpr8a6ysr">
        {testimonial.nombre} | {testimonial.edad} años | {testimonial.ciudad}
      </p>
      <p className="mt-1 flex items-center gap-1 text-xs text-success" data-id="element-195" data-mp="8288d581211n">
        <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-196" data-mp="33ydywu4n4h3" /> Compra verificada
      </p>
    </div>;
}